import { render, staticRenderFns } from "./NewBiepriv.vue?vue&type=template&id=3a145255&scoped=true"
import script from "./NewBiepriv.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewBiepriv.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NewBiepriv.vue?vue&type=style&index=0&id=3a145255&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a145255",
  null
  
)

export default component.exports